import {offlineConversationContents} from '../../../srcCommon/services/offline/offlineConversationContents';
import {batch} from '../../helpers/reduxHelpers';
import {ApiConversationDataGroup} from '../../models/api/dataGroupModel';
import {ThunkAction} from '../../store/appThunk';
import {updateDataAction} from '../../store/data/dataGroupsActions';
import {deleteApiAsync} from '../http/http';
import {findActivityQueue} from './specializedTaskQueues';

export function deleteActivityTask(activityId: number): ThunkAction {
  return async (dispatch, getState) => {
    const activityQueue = findActivityQueue(dispatch, getState, activityId);
    const activity = activityQueue.get();
    if (!activity) {
      return;
    }

    // Delete instantly from the store.
    activityQueue.delete();

    const pendingTaskIsDone = offlineConversationContents.addPendingOfflineTask({
      type: 'deleteActivity',
      conversationId: activity.conversationId,
      activityId: activity.id,
    });

    await activityQueue.waitForTurnAsync();
    try {
      // TODO: Set the activity deletedAt based on the result here.
      const result = await deleteApiAsync(
        ApiConversationDataGroup,
        `${activity.url}?include_conversation=true`,
      );

      batch(() => {
        dispatch(updateDataAction(result));
        activityQueue.reportDeleted();
      });
    } catch (error) {
      activityQueue.reportError();
      throw error;
    } finally {
      pendingTaskIsDone();
    }
  };
}
